module.exports = __webpack_public_path__ + "img/teachingmanagement_2.866fae14.jpg";